import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const BookPlusIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9975 17.0025L2.87937 17.0025C2.39114 17.0025 1.99199 16.6061 2.00012 16.118C2.00195 16.0086 2.00407 15.9462 2.0061 15.9081C2.03257 15.4117 2.40522 15.0022 2.90233 15.0022L14.9975 15.0022L14.9975 2.88403C14.9975 2.39579 15.3933 2 15.8815 2L16.1138 2C16.602 2 16.9978 2.39579 16.9978 2.88403L16.9978 15.0022L29.116 15.0022C29.6042 15.0022 30 15.398 30 15.8862V16.1185C30 16.6067 29.6042 17.0025 29.116 17.0025L16.9978 17.0025L16.9978 29.1206C16.9978 29.6089 16.6015 30.008 16.1133 29.9999C16.0039 29.9981 15.9415 29.9959 15.9034 29.9939C15.407 29.9674 14.9975 29.5948 14.9975 29.0977L14.9975 17.0025Z" fill={fill}/>
  </svg>
);

export default BookPlusIcon;import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const BookPlusIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9975 17.0025L2.87937 17.0025C2.39114 17.0025 1.99199 16.6061 2.00012 16.118C2.00195 16.0086 2.00407 15.9462 2.0061 15.9081C2.03257 15.4117 2.40522 15.0022 2.90233 15.0022L14.9975 15.0022L14.9975 2.88403C14.9975 2.39579 15.3933 2 15.8815 2L16.1138 2C16.602 2 16.9978 2.39579 16.9978 2.88403L16.9978 15.0022L29.116 15.0022C29.6042 15.0022 30 15.398 30 15.8862V16.1185C30 16.6067 29.6042 17.0025 29.116 17.0025L16.9978 17.0025L16.9978 29.1206C16.9978 29.6089 16.6015 30.008 16.1133 29.9999C16.0039 29.9981 15.9415 29.9959 15.9034 29.9939C15.407 29.9674 14.9975 29.5948 14.9975 29.0977L14.9975 17.0025Z" fill={fill}/>
  </svg>
);

export default BookPlusIcon;